const { Type } = require('@sinclair/typebox');

/** Builds the TypeBox schema fragment for the Currency form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, min, max, required, defaultValue } = hNode;

    const subDataDictionary = {};

    // Determine optional/editable flags based on the context (readOnly) and the required flag.
    let optional;
    let editable;
    if (!context?.readOnly) {
        editable = true;
        if (!required) {
            optional = true;
        }
    }

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) => (optional ? Type.Optional(schema) : schema);

    // Build the number schema with currency format and constraints (using x-format since 'currency' is not a standard JSON Schema format)
    const numberOptions = {
        title: title,
        'x-format': 'currency',
        'x-id': id,
        'x-dataType': 'number',
        'x-propertyName': propertyName,
        'x-optional': !!optional,
        'x-editable': !!editable
    };

    // Add min/max constraints if provided
    if (min !== undefined && min !== null) {
        numberOptions.minimum = min;
    }
    if (max !== undefined && max !== null) {
        numberOptions.maximum = max;
    }
    if (defaultValue !== undefined && defaultValue !== null) {
        numberOptions.default = defaultValue;
    }

    const currencySchema = maybeOptional(Type.Number(numberOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: currencySchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
